import { useCustomTranslation } from '../../../localization/hooks/useCustomTranslation';
import { moduleId } from '../config';

const useContactsTranslation = (keyPrefix: string) => useCustomTranslation({ moduleId, keyPrefix });

export default useContactsTranslation;
